import { Box } from '@mui/material';
import { PaintBlockTopFilter } from './PaintBlockTopFilter';
import { CustomBlockList } from './CustomBlockList';
import { useAtom, useAtomValue } from 'jotai';
import * as localState from '../state';
import { SelectedCustomBlockPanel } from './SelectedCustomBlockPanel';
import { useCallback, useMemo } from 'react';
import { SelectedPoiContent } from '../../pointOfInterest/PointOfInterestTab/SelectedPoiContent';
import { useIsolateCustomBlock } from '../hooks';

export const CustomBlocksTab = ({ resetFocus = true }: { resetFocus?: boolean }) => {
  const selectedCustomBlock = useAtomValue(localState.selectedCustomBlock);
  const [selectedSavedBlockId, setSelectedSavedBlockId] = useAtom(localState.selectedSavedBlockId);

  const { deSelectCustomBlock } = useIsolateCustomBlock({ resetFocus });

  const closeHandler = useCallback(() => {
    setSelectedSavedBlockId(undefined);
    deSelectCustomBlock();
  }, [setSelectedSavedBlockId, deSelectCustomBlock]);

  const selectedPoiDisplayComponent = useMemo(() => {
    if (!selectedSavedBlockId) return <></>;
    return (
      <SelectedPoiContent
        selectedPoiId={selectedSavedBlockId}
        closeHandler={closeHandler}
        resetFocus={resetFocus}
      />
    );
  }, [closeHandler, selectedSavedBlockId, resetFocus]);
  if (selectedSavedBlockId) return selectedPoiDisplayComponent;
  if (selectedCustomBlock) return <SelectedCustomBlockPanel />;
  return (
    <Box sx={{ height: '100%', overflowY: 'hidden', p: 0 }}>
      <PaintBlockTopFilter compact sx={{ mt: 2, px: 1, gap: 1 }} />
      <CustomBlockList />
    </Box>
  );
};
